import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class UltrasonicSensorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'ultrasonicSensor',
            name: 'Ultrasonic',
            color1: '#0F62FE',
            color2: '#0043CE',
            color3: '#002D9C',

            blocks: [
                {
                    opcode: 'ultrasonic_readDistance',
                    blockType: 'reporter',
                    text: formatMessage({
                        id: 'ultrasonicSensor.blocks.readDistance',
                        default: 'read ultrasonic distance (cm) trig [TRIG] echo [ECHO]'
                    }),
                    arguments: {
                        TRIG: {
                            type: 'number',
                            defaultValue: '6',
                            menu: 'digitalPinMenu'
                        },
                        ECHO: {
                            type: 'number',
                            defaultValue: '7',
                            menu: 'digitalPinMenu'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'ultrasonic_readDistance',
                    type: 'reporter',
                    arduino: {
                        code: '(() -> { digitalWrite({{TRIG}}, LOW); delayMicroseconds(2); digitalWrite({{TRIG}}, HIGH); delayMicroseconds(10); digitalWrite({{TRIG}}, LOW); long duration = pulseIn({{ECHO}}, HIGH); return duration * 0.034 / 2; })()',
                        setup: ['pinMode({{TRIG}}, OUTPUT);', 'pinMode({{ECHO}}, INPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'ultrasonic_read({{TRIG}}, {{ECHO}})',
                        setup: [
                            'pin_{{TRIG}} = Pin({{TRIG}}, Pin.OUT)',
                            'pin_{{ECHO}} = Pin({{ECHO}}, Pin.IN)',
                            'def ultrasonic_read(t, e):',
                            '    pin_t = Pin(t, Pin.OUT)',
                            '    pin_e = Pin(e, Pin.IN)',
                            '    pin_t.low()',
                            '    time.sleep_us(2)',
                            '    pin_t.high()',
                            '    time.sleep_us(5)',
                            '    pin_t.low()',
                            '    while pin_e.value() == 0:',
                            '        signaloff = time.ticks_us()',
                            '    while pin_e.value() == 1:',
                            '        signalon = time.ticks_us()',
                            '    timepassed = signalon - signaloff',
                            '    return (timepassed * 0.0343) / 2'
                        ],
                        imports: ['from machine import Pin', 'import time']
                    }
                }
            ]
        };
    }

    ultrasonic_readDistance (args) {
        return Math.floor(Math.random() * 400); // UI Simulate 0-400cm
    }
}

export default UltrasonicSensorExtension;
